module.exports = __webpack_public_path__ + "img/hoovi_logo.2a411bb3.png";